<template>
    <el-drawer
        title="退款订单详情"
        :visible.sync="showPop"
        :direction="direction"
        :custom-class="classNames+ '_wrap'"
        @close="handleClose">
        <div :class="classNames" v-loading="isLoading === 'noFullScreen'">
            <el-scrollbar style="flex: 1" ref="scrollbar">
                
                <div :class="classNames+ '_content'">
                    <div :class="classNames+ '_content_title'">售后信息</div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">退款状态</div>
                        <div :class="classNames+ '_content_item_con'">{{detailObj.cus_add_status_text}}</div>
                    </div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">售后单号</div>
                        <div :class="classNames+ '_content_item_con'">{{detailObj.after_sale_order_id}}</div>
                    </div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">交易金额</div>
                        <div :class="classNames+ '_content_item_con'">¥{{detailObj.order_price}}</div>
                    </div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">退款金额</div>
                        <div :class="classNames+ '_content_item_con'">¥{{detailObj.refund_amount}}</div>
                    </div>

                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">售后商品</div>
                        <div :class="classNames+ '_content_item_class'">
                            <img :src="detailObj.product_img" alt=""/>
                            <div :class="[classNames+ '_content_item_con', classNames+ '_content_item_class_text']">
                                <p>{{detailObj.product_title}}</p>
                                <p>￥{{detailObj.order_price}} / {{ detailObj.scount }}件</p>
                            </div>
                        </div>
                    </div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">申请原因</div>
                        <div :class="classNames+ '_content_item_con'">{{detailObj.reason_text}}</div>
                    </div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">申请时间</div>
                        <div :class="classNames+ '_content_item_con'">{{detailObj.create_time}}</div>
                    </div>
                </div>
                <div :class="classNames+ '_content'">
                    <div :class="classNames+ '_content_title'">订单信息</div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">订单状态</div>
                        <div :class="classNames+ '_content_item_con'">{{detailObj.order_status}}</div>
                    </div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">订单编号</div>
                        <div :class="classNames+ '_content_item_con'">{{detailObj.order_id}}</div>
                    </div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">购买手机号</div>
                        <div :class="classNames+ '_content_item_con'">{{detailObj.details_tel_number}}</div>
                    </div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">下单时间</div>
                        <div :class="classNames+ '_content_item_con'">{{detailObj.order_created_time}}</div>
                    </div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">支付方式</div>
                        <div :class="classNames+ '_content_item_con'">{{detailObj.payment}}</div>
                    </div>
                    <div :class="classNames+ '_content_item'">
                        <div :class="classNames+ '_content_item_label'">支付时间</div>
                        <div :class="classNames+ '_content_item_con'">{{detailObj.order_pay_time}}</div>
                    </div>
                </div>
            </el-scrollbar>
        </div>
    </el-drawer>
</template>
<script>
import { mapState } from 'vuex'
export default {
    props: {
        value: {
            type: Boolean,
            default: false
        },
        detailObj: { // 详情
            type: Object,
            default: ()=> {
                return {}
            }
        },
    },
    created() {
        this.$watch(() => this.value, (news) => {
            this.showPop = news
        })
    },
    data() {
        return {
            direction: 'rtl',
            classNames: 'drawer',
            showPop: false // 展示弹窗
        }
    },
    computed: {
        ...mapState(['isLoading'])
    },
    methods: {
        handleClose() {
            this.$emit('input', false)
        },
    },
}
</script>
<style lang="less">
    @classNames: drawer;
    .@{classNames}_wrap {
        .el-drawer__body {
            height: 0;
        }
        .el-drawer__header {
            height: 48px;
            span {
                font-size: 20px;
                font-weight: 600;
                color: #37383c;
            }
        }
    }
</style>
<style lang="less" scoped>
    @classNames: drawer;
    .@{classNames} {
        display: flex;
        flex-direction: column;
        height: 100%;
        .@{classNames}_content {
            padding: 20px;
            border-top: 1px solid rgb(243, 244, 249);
            .@{classNames}_content_title {
                font-size: 14px;
                font-weight: 600;
                color: #37383c;
            }
            .@{classNames}_content_item {
                background-color: #fff;
                display: flex;
                margin-top: 20px;
                font-size: 14px;
                .@{classNames}_content_item_label {
                    width: 70px;
                    margin-right: 40px;
                    color: #888a95;
                    flex-shrink: 0;
                    // line-height: 36px;
                    &.lone-width{
                        width: 130px;
                        margin-right: 10px;
                    }
                }
                .@{classNames}_content_item_con {
                    color: #333;
                }
                .@{classNames}_statur_state {
                    min-width: 53px;
                    max-width: 100px;
                    height: 18px;
                    line-height: 18px;
                    border-radius: 10px;
                    font-size: 12px;
                    text-align: center;
                    line-height: 20px;
                    padding: 0 5px;
                    margin-right: 5px;
                    flex-shrink: 0;
                }
                .reason {
                    margin-left: 6px;
                    font-size: 12px;
                    word-break: break-all;
                }
                .@{classNames}_content_item_status_success {
                    border: 1px solid rgb(50, 178, 66);
                    color: rgb(50, 178, 66);
                }
                .@{classNames}_content_item_status_error {
                    color: #888a95;
                    border: 1px solid #888a95;
                }
                .@{classNames}_content_item_class {
                    display: flex;
                    img {
                        width: 120px;
                        height: 90px;
                        border-radius: 8px;
                        margin-right: 15px;
                    }
                    .@{classNames}_content_item_class_text {
                        p {
                            &:not(:first-child) {
                                margin-top: 10px;
                            }
                        }
                    }
                }
                .@{classNames}_content_item_pay {
                    display: flex;
                    align-items: center;
                    img {
                        margin-right: 15px;
                        width: 32px;
                        height: 32px;
                        border-radius: 50%;
                    }
                }
            }
        }
        .@{classNames}_content_item_inp {
            display: flex;
            align-items: center;
            .oper {
                margin-left: 12px;
            }
            .con-input {
                width: 200px;
                height: 32px;
                /deep/.el-input__inner {
                    height: 32px;
                    line-height: 32px;
		        }
            }
            .edit {
                color: #1989FA;
                margin-left: 12px;
                white-space: nowrap;
                cursor: pointer;
            }
            .text {
                word-break: break-all;
            }
        }
    }
    .content-item-right{
        display: flex;
        flex-direction: column;
        .@{classNames}_content_item_class{
            margin-bottom: 10px;
        }
    }
</style>
